import React from 'react'
import { CommonProgressSpinnerProps } from '../../types/common'
import { ProgressSpinner } from 'primereact/progressspinner'

const SpinnerWithBackground = () => {
    return (
        <>
            <div
                style={{
                    zIndex: 1001,
                    background: '#fff',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: '1em',
                    minWidth: '210px',
                    width: '40%',
                    borderRadius: '1em',
                    position: 'absolute',
                    border: '1px black',
                    top: '45%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    boxShadow: '4px 4px 5px 0px #969696',
                }}
            >
                <ProgressSpinner />
                <div>Loading...</div>
            </div>
            <div
                style={{
                    zIndex: 1000,
                    background: '#0000003b',
                    width: '100vw',
                    height: '100vh',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                }}
            ></div>
        </>
    )
}

const CommonProgressSpinner = (props: CommonProgressSpinnerProps) => {
    return (
        <>
            {props.withBackground ? (
                <SpinnerWithBackground />
            ) : (
                <ProgressSpinner
                    style={{
                        position: 'absolute',
                        top: props.top,
                        left: props.left,
                        transform: `translate(${props.transformX || '-50%'}, ${props.transformY || '-50%'})`,
                    }}
                />
            )}
        </>
    )
}

export default CommonProgressSpinner
